import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

/**
 * @arg {String} userId - The id of the user we want to look up
 * @return {Object} - A redux-saga call effect
 */
export const getMapleUser = userId =>
  call(websocketFetch, 'get_maple_user', { user_id: userId });
